module.exports = __webpack_public_path__ + "img/welcome_visual_img_02.83935219.svg";